import {get} from "lodash";
import * as axios from "axios";
import config from "../config";
import {getConfig} from "../config/faq-config-helper";

const {searchKey, endpointBase, engineName} = getConfig();
const url = `${endpointBase}/api/as/v1/engines/${engineName}/search`;
const getGlobalFilters = () =>
  ({all: get(config, "searchQuery.filters", []).map(f => ({any: [{[f.field]: f.values[0]}]}))})

class ElasticSearchApiService {
  async fetchProductCategories() {
    return this.fetchUniqueFieldValues("field_faq_product_categories");
  }

  async fetchUniqueFieldValues(field) {
    const query = {
      query: "",
      filters: getGlobalFilters(),
      group: {
        field,
      },
    };

    return this.fetch(query).then((fields) => fields.map(f => f._group_key));
  }

  async fetch(query) {
    const config = {
      method: 'post',
      url: url,
      headers: { 
        'Authorization': `Bearer ${searchKey}`, 
        'Content-Type': 'application/json'
      },
      data : query
    };

    return axios(config)
    .then(function (response) {
      return response.data.results;
    })
    .catch(function (error) {
      console.error(error);
      return [];
    });
  }
}

export default new ElasticSearchApiService();
